<template>
<div class="container-fluid m-0 p-0">

  <div id="home-page" class="full-height  p-4" >
    <div class="container pt-3" >
<!-- Linke Seite -->
      <div class="row pb-5">
        <div class="col-lg-6 pt-4 my-auto">
          <!-- Grosser Bildschirm Titel rechte Seite d-block d-lg-none -->
          <div class="mydiv text-center mb-3 d-block d-lg-none">
          <h1 class="display-3">{{ title }}</h1>
          <!-- <h3>GIB</h3> -->
          </div>
          <!-- <img id="bottle-img" src="../assets/wordcloud.svg" class="img-fluid"> -->

        </div>
<!-- rechte Seite -->
        <div class="col-lg-6 my-auto pt-4">
          <!-- Grosser Bildschirm Titel oberhalb d-none d-lg-block -->
          <div class="text-center mb-3 d-none d-lg-block">
          <!-- <h1 class="display-3">{{ title }}</h1> -->
          <!-- <h3>GIB</h3> -->
          </div>




          <div id="contact" class="p-4">

          <h2>GIB Event</h2>

           <div class="form-group" id="email-font">
              <label for="emailSignup" id="event">Impresionen GIB Event</label><br>
              <form ref="form" @submit.prevent="sendEmail" id="felder">

                  <div class="form-group row" >
                <label></label>
                      <input
                        type="text"
                        v-model="name"
                        name="name"
                        placeholder="Din Name"
                        class="form-control"
                      >
                    </div><br>

                      <label></label>
                    <div class="form-group row">
                      <input
                        type="email"
                        v-model="email"
                        name="email"
                        placeholder="Dini Mailadressa"
                        class="form-control"
                        >

                  </div><br>

                  <div class="form-group row">
                    <label></label>
                      <textarea
                        name="message"
                        v-model="message"
                        cols="30" rows="5"
                        placeholder="Dini Nachricht, Allergie, und sustigi Gebräche"
                        class="form-control">
                      </textarea>
                    </div><br>

                      <input type="submit" value="Send" class="btn btn-primary btn-lg" id="sendButton">


              </form>
            </div> -->


        </div>


        </div>
      </div>

    </div>
  </div>



  <!-- Quotes -->
  <!-- <div id="about" class="p-3 p-md-5">
    <div class="row pt-5">
      <div class="col-lg">
        <img src="../assets/icons/hand_vector.svg"  height="120" class="n-4 pb-4">
        <h5>"Wie meine Grossmutter immer gesagt hat: Gib GIB!"</h5>
      </div>

      <div class="col-lg">
        <img src="../assets/icons/hand_vector.svg"  height="120" class="n-4 pb-4">
        <h5>"Schon Konfuzius hat gesagt: Ein Geheimnis ist besser als Wissen. Deswegen abwarten und Vorfreude geniessen"</h5>
      </div>

      <div class="col-lg">
        <img src="../assets/icons/hand_vector.svg"  height="120" class="n-4 pb-4">
        <h5>"Isch das nu en Vorgfertigte Text zum lüt zum lacha bringa? Und hanis gschafft? OOOOOOOOOOOKKKKKKK LETS GOOOOOOOO. So muass wiedercode wem au immer i
          das grad zeiga (looking at you Philip, Robin und waaaaaaaaarschinli Jannis). Aber es klappt leck du miar doch am Tschöppli bin i durch. Hoffa
          iar sind alli schlauer und codend das nid selber. "</h5>
      </div>

    </div>
  </div> -->

  <!-- <div id="contact" class="p-4">
    <div class="row justify-content-center mt-3 mb-3">

       <div class="col-md-6">
        <h2>Irgendwelichi Frage?</h2>
        <p>Kontaktier ünsch doch wenn alles füllsch us Bruder!</p>

        <form ref="form" @submit.prevent="sendEmail">
          <label></label>
                <input
                  type="text"
                  v-model="name"
                  name="name"
                  placeholder="Your Name"
                >
                <label></label>
                <input
                  type="email"
                  v-model="email"
                  name="email"
                  placeholder="Your Email"
                  >
                <label></label>
                <textarea
                  name="message"
                  v-model="message"
                  cols="30" rows="5"
                  placeholder="Message">
                </textarea><br>

                <input type="submit" value="Send">
        </form>



      </div>


    </div>

  </div> -->

  <!-- <div id="footer" class="p-4">
    <footer class="text-light p-4">
      <a href="https://www.youtube.com/watch?v=dQw4w9WgXcQ" target="_blank" class="text-warning">Nicht drücken!</a><br>
      <a href="#" class="text-warning">Back to Top</a>
      <br>
      <small>&copy; 2022, GIB "the Legend"</small>
     </footer>

  </div> -->

</div>


</template>

<script>


import emailjs from 'emailjs-com';

export default {
  name: 'ContactUs',
  data() {
    return {
      name: '',
      email: '',
      message: ''
    }
  },
  methods: {
    sendEmail() {
      emailjs.sendForm("service_dpn73lf","template_8jahc3m", this.$refs.form, '6Q8MF0-3MueBx6c7F', {
          name: this.name,
          email: this.email,
          message: this.message
        })
        .then((result) => {
            console.log('SUCCESS!', result.text);
        }, (error) => {
            console.log('FAILED...', error.text);
        });
      this.name = ''
      this.email = ''
      this.message = ''
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>



#home-page {
  background-color: #92D2F2;
  background: url("../assets/gib_landingpage.jpg") no-repeat center center;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}
.mydiv{
  position: relative;
}

#bottle-img {
  max-height: 100vh;


}

#about{
  min-height: 40vh;
  background-color: #d9d9d9;
}

#contact{
  margin-left: auto;
  margin-right: auto;

}

#footer{
  background-color: rgba(0, 0, 0, 0.99);
}

#email-font{
  color: white;
  font-family: cheap-pine-sans, sans-serif;
  font-weight: 400;
  font-style: normal;
}

#event{

  font-size: 4rem;

}

#felder{
  font-family: roboto;

}

#sendButton{
padding: 1rem 7rem;

}



h2{
  color: white;
  font-family: cheap-pine-sans, sans-serif;
  font-weight: 400;
  font-style: normal;
  font-size: 10rem;

}





</style>
